import PropTypes from "prop-types";
import clsx from "clsx";
import Tab from "react-bootstrap/Tab";
import Nav from "react-bootstrap/Nav";
import { usePartner } from "../../helpers/BrandPageAPI";
import { useNavigate } from "react-router-dom";


const ProductDescriptionTab = ({ spaceBottomClass, product }) => {
  const { partnerData } = usePartner();
  const ButtonColor = partnerData?.StoreColor;

  return (
    <div className={clsx("description-review-area", spaceBottomClass)}>
      <div className="container">
        <div className="description-review-wrapper">
          <Tab.Container defaultActiveKey="additionalInfo">
            <Nav variant="pills" className="description-review-topbar" >
              <Nav.Item>
                <Nav.Link style={{ background: ButtonColor }} eventKey="additionalInfo">PRODUCT DETAILS</Nav.Link>
              </Nav.Item>
            </Nav>
            <Tab.Content className="description-review-bottom">
              <Tab.Pane eventKey="additionalInfo">
                <div className="product-anotherinfo-wrapper">
                  <table>
                    <tbody>
                      <tr>
                        <td>Sub Category :</td>
                        <td>{product.SubCategory}</td>
                      </tr>
                      <tr>
                        <td>Net Weight :</td>
                        <td>{product.NetWt} GM</td>
                      </tr>
                      <tr>
                        <td>Gross Weight :</td>
                        <td>{product.GrossWt} GM</td>
                      </tr>
                      <tr>
                        <td>Stock Type :</td>
                        <td>{product.StockType}</td>
                      </tr>
                      <tr>
                        <td>Manufacturer :</td>
                        <td>{product.Manufacturer}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </Tab.Pane>
            </Tab.Content>
          </Tab.Container>
        </div>
      </div>
    </div>
  );
};

ProductDescriptionTab.propTypes = {
  productFullDesc: PropTypes.string,
  spaceBottomClass: PropTypes.string,
};

export default ProductDescriptionTab;
